import { render, staticRenderFns } from "./SystemAssignPermissions.vue?vue&type=template&id=11c13eb2&scoped=true&"
import script from "./SystemAssignPermissions.vue?vue&type=script&lang=js&"
export * from "./SystemAssignPermissions.vue?vue&type=script&lang=js&"
import style0 from "./SystemAssignPermissions.vue?vue&type=style&index=0&id=11c13eb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c13eb2",
  null
  
)

export default component.exports